
export const LANG_EN ='en';  
export const LANG_AR ='ar';  